type ErrorShape = {
  stack?: string
  status?: number
  statusText?: string
  description?: string
  data?: {
    msg?: string
    status?: string
    title?: string
    detail?: string
  }
  line?: number
  column?: number
  sourceURL?: string
  // SC shape
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Error?: any
}

type Input = ErrorShape | string | null | undefined

export default function getErrorMessage(err: Input): string {
  if (!err) {
    return "unknown error"
  }

  if (typeof err === "string") {
    return err
  }

  if (err instanceof Error) {
    // @ts-expect-error: Flow to TS migration.
    if (err.data) {
      // @ts-expect-error: Flow to TS migration.
      if (err.data.detail === "price change") {
        return `price_change`
      }

      // @ts-expect-error: Flow to TS migration.
      if (err.data.msg) {
        // @ts-expect-error: Flow to TS migration.
        return err.data.msg
      }
      // @ts-expect-error: Flow to TS migration.
      if (err.data.title && err.data.detail) {
        // Fix this the next time the file is edited. (Flow to TS)
        // @ts-expect-error: Flow to TS migration.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return `${err.data.title} ${err.data.detail}`
      }
    }
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    return err.toString()
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  if (err.data && err.data.msg) {
    return err.data.msg
  }

  if (err.statusText) {
    return err.statusText
  }

  // SC shape
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  if (err.Error && err.Error.title) {
    return err.Error.title
  }

  return "unknown error"
}
